export default "__VITE_ASSET__l2DCUs52Uq2oIOe0iK6upA__"